import * as React from 'react';
import { connect } from 'react-redux';

// Actions
// @ts-ignore
import { resetSelectedTableCells as resetSelectedTableCellsAction } from 'services/selectedTableCells/actions';

interface Props {
    resetSelectedTableCells: Function;
}

export class ResetSelectedTableCellsOnUmnount extends React.PureComponent<
    Props
> {
    componentWillUnmount(): void {
        const { resetSelectedTableCells } = this.props;

        resetSelectedTableCells();
    }

    render(): null {
        return null;
    }
}

export default connect(
    null,
    {
        resetSelectedTableCells: resetSelectedTableCellsAction
    }
)(ResetSelectedTableCellsOnUmnount);
